import { render, staticRenderFns } from "./customer-payments.component.vue?vue&type=template&id=0dc700d6&scoped=true"
import script from "./customer-payments.component.vue?vue&type=script&lang=js"
export * from "./customer-payments.component.vue?vue&type=script&lang=js"
import style0 from "./customer-payments.component.vue?vue&type=style&index=0&id=0dc700d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc700d6",
  null
  
)

export default component.exports